import axios from "axios"
import { addBankAccount, addIdentityValidation, addImageVerification, validateOtpEmail, validateOtpSms, resendOtp, getBankList, getListApprovedBankAccounts, deleteApprovedBankAccount, getWithdrawals, addRequestCashWithdrawals, validateOtpEmailWithdrawal, validateOtpSmsWithdrawal } from "../api/bank-account"
import { Decimal } from 'decimal.js'

import Alert from "../components/alert-component/AlertComponent.js"
import { logoSearch } from "../utils/logoSearch"
import { bankNameHandler } from "../utils/bankNameHandler"

import { handleErrorCode } from "../utils/errorCodeHandler"

export default {
	data() {
		return {
			// list of banks that can be selected
			bankList: [],
			isLoadingGetBankList: false,
			isErrorGetBankList: false,

			// list of approved bank accounts, both verified AND on process
			bankListApproved: [],
			isLoadingBankListApproved: false,
			isErrorBankListApproved: false,

			// list of approved bank accounts that are on process only
			bankListOnProcess: [],

			isLoadingAddBankAccount: false,
			addBankAccountController: null,

			addBankAccountStatus: null,
			addBankAccountVerifiedData: null,

			// identity validation
			isIdNumberUnmatch: false,
			isMotherNameUnmatch: false,
			idNumberErrors: [],
			motherNameErrors: [],
			isIdentityValidationLocalError: false,

			listWithdrawals: [],
			withdrawalAmountErrors: [],
			withdrawalDescriptionErrors: [],
		}
	},

	beforeDestroy() {
		if (this.addBankAccountController) {
			this.addBankAccountController.abort() // Ensure request is canceled when component is destroyed
		}
	},

	methods: {
		simulateApi() {
			// simulate async api call
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve()
				}, 2000)
			})
		},

		getListApprovedBankAccounts(params) {
			this.isLoadingBankListApproved = true
			this.isErrorBankListApproved = false

			return new Promise(async (resolve, reject) => {
				try {
					const response = await getListApprovedBankAccounts(params)
					this.isLoadingBankListApproved = false
					return resolve(response)
				} catch (error) {
					console.log('error', error)
					this.isLoadingBankListApproved = false
					this.isErrorBankListApproved = true
					return reject()
				}
			})
		},

		setBankListApproved(params) {
			this.getListApprovedBankAccounts(params).then(response => {
				this.bankListApproved = response.data.map(item => {
					const bankLogo = logoSearch(item.bank_code, 'bankSquare')
					const bankName = bankNameHandler(item.bank_code, 'short')
					return {
						_id: item._id,
						bankName: bankName || item.bank_name,
						bankLogo: bankLogo,
						accountNumber: item.account_no,
						type: item.type,
						accountName: item.account_name || this.$store.getters.getFullName,
						canDelete: item.can_delete,
						status: item.status === 'ACCEPTED' ? 'Verified' : 'Diproses',
					}
				})

				this.bankListOnProcess = this.bankListApproved.filter(item => item.status === 'Diproses')
			})
		},

		async addBankAccount(data) {
			if (this.addBankAccountController) {
				this.addBankAccountController.abort() // Cancel any ongoing request before starting a new one
			}
			this.addBankAccountController = new AbortController() // Create a new controller for the new request

			this.isLoadingAddBankAccount = true

			try {
				if (!data.account_no) {
					this.isLoadingAddBankAccount = false
					this.addBankAccountStatus = 'failed'
					return
				}

				const payload = {
					...data,
					user_id: this.$store.state.authInfo.user_id,
				}
				const config = {
					signal: this.addBankAccountController.signal
				}
				const response = await addBankAccount(payload, config)

				this.addBankAccountVerifiedData = {
					bankName: response.data.bank_name,
					accountNumber: response.data.account_no,
					accountName: response.data.account_name,
					logoCode: response.data.bank_code,
				}

				this.addBankAccountStatus = 'verified'

				this.$store.dispatch('bankAccount/setRequestKeyAddBankAccount', response.data.request_key)

				this.isLoadingAddBankAccount = false
				// Alert.close()

				// this.$router.push({ name: 'Identity Verification' })
			} catch (error) {
				if (axios.isCancel(error)) {
					return
				}

				this.isLoadingAddBankAccount = false

				this.addBankAccountStatus = 'failed'

				let errorMessage = handleErrorCode(error.response.data.data.status_code) || {
					title: error.response.data.data.message || 'Proses Invalid',
					message: error.response.data.data.message || 'Terdapat kesalahan pada proses penambahan rekening. Silakan coba lagi.'
				}

				Alert.open({
					type: 'error',
					title: errorMessage.title,
					description: errorMessage.message
				})

				console.log('error', error)
			}
		},

		deleteApprovedBankAccount(id) {
			Alert.open({
				type: 'confirm',
				title: 'Konfirmasi',
				description: 'Apakah anda yakin ingin menghapus data ini?',
				onConfirm: async () => {
					Alert.open({
						type: 'loading',
						title: 'Sedang Memproses',
						description: 'Mohon tunggu sebentar'
					})

					try {
						await deleteApprovedBankAccount(id)

						Alert.open({
							type: 'success',
							title: 'Berhasil',
							description: 'Data berhasil dihapus'
						})

						this.setBankListApproved()
					} catch (error) {
						Alert.open({
							type: 'error',
							title: 'Gagal',
							description: 'Terjadi kesalahan saat menghapus'
						})

						console.log('error', error)
					}
				}
			})
		},

		isIdNumberError(idNumber) {
			let isError = false

			// is numeric
			const regexIsNumeric = /^\d+$/
			const isNumeric = regexIsNumeric.test(idNumber)
			if (!isNumeric) {
				this.idNumberErrors.push('Nomor KTP harus berupa angka')
				isError = true
			}

			// is 16 digits
			const regexIs16Digits = /^\d{16}$/
			const is16Digits = regexIs16Digits.test(idNumber)
			if (!is16Digits) {
				this.idNumberErrors.push('Nomor KTP harus 16 digit')
				isError = true
			}

			return isError
		},

		isMotherNameError(motherName) {
			let isError = false

			// cannot empty
			if (!motherName) {
				this.motherNameErrors.push('Nama ibu kandung tidak boleh kosong')
				isError = true
			}

			return isError
		},

		async addIdentityValidation(data) {
			this.isIdNumberUnmatch = false
			this.isMotherNameUnmatch = false
			this.idNumberErrors = []
			this.motherNameErrors = []
			this.isIdentityValidationLocalError = false

			Alert.open({
				type: 'loading',
				title: 'Sedang Memproses',
				description: 'Mohon tunggu sebentar'
			})

			try {
				if (this.isIdNumberError(data.id_no) || this.isMotherNameError(data.mother_name)) {
					this.isIdentityValidationLocalError = true
					throw 'error local'
				}

				const payload = {
					...data,
					user_id: this.$store.state.authInfo.user_id,
					request_key: this.$store.state.bankAccount.requestKeyAddBankAccount
				}

				const response = await addIdentityValidation(payload)

				this.$store.dispatch('bankAccount/setValidationString', response.data.validation_string)

				// change which process addBankAccount to 'photo'
				this.$store.commit('bankAccount/setWhichProcessAddBankAccount', 'photo')

				this.$router.push({ name: 'Take Photo' })

				Alert.close()
			} catch (error) {
				if (this.isIdentityValidationLocalError) {
					Alert.close()
					return
				}

				if (error.response.data.data.status_code === 'IdNumberUnmatch') {
					this.isIdNumberUnmatch = true
				}

				if (error.response.data.data.status_code === 'MotherNameUnmatch') {
					this.isMotherNameUnmatch = true
				}

				let errorMessage = handleErrorCode(error.response.data.data.status_code) || {
					title: error.response.data.data.message || 'Proses Invalid',
					message: error.response.data.data.message || 'Terdapat kesalahan pada proses penambahan rekening. Silakan coba lagi.'
				}

				Alert.open({
					type: 'error',
					title: errorMessage.title,
					description: errorMessage.message,
					onClose: () => {
						// request key expired. Restart from the beginning
						if (error.response.data.data.status_code === 'BankAccountRequestInvalid') {
							this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
							this.$router.push({ name: 'Add Bank Account' })
						}
					}
				})

				console.log('error', error)
			}

		},

		addImageVerification(data) {
			return new Promise(async (resolve, reject) => {
				Alert.open({
					type: 'loading',
					title: 'Sedang Memproses',
					description: 'Mohon tunggu sebentar'
				})

				try {
					const formData = new FormData()
					formData.append('image', data.image, 'photo.jpg')
					formData.append('user_id', this.$store.state.authInfo.user_id)
					formData.append('request_key', this.$store.state.bankAccount.requestKeyAddBankAccount)
					formData.append('validation_string', this.$store.state.bankAccount.validationString)

					await addImageVerification(formData)

					// await this.simulateApi()

					Alert.close()

					return resolve()
				} catch (error) {

					let errorMessage
					if (error.response.data.data.status_code === 'OTPResendExceededLimit') {
						errorMessage = this.otpErrorCodeHandler(error)
					} else {
						errorMessage = handleErrorCode(error.response.data.data.status_code) || {
							title: error.response.data.data.message || 'Proses Invalid',
							message: error.response.data.data.message || 'Terdapat kesalahan pada proses penambahan rekening. Silakan coba lagi.'
						}
					}

					Alert.open({
						type: 'error',
						title: errorMessage.title,
						description: errorMessage.message
					})

					return reject()
				}
			})
		},

		/**
			* Validate OTP Email
			* @param {Object} data
			* @param {'addBankAccount' | 'withdrawal'} process
		*/
		validateOtpEmail(data, process = 'addBankAccount') {
			return new Promise(async (resolve, reject) => {
				Alert.open({
					type: 'loading',
					title: 'Sedang Memproses',
					description: 'Mohon tunggu sebentar'
				})

				try {
					const requestKey = process === 'addBankAccount' ? this.$store.state.bankAccount.requestKeyAddBankAccount : this.$store.state.bankAccount.requestKeyWithdrawal
					const payload = {
						...data,
						user_id: this.$store.state.authInfo.user_id,
						request_key: requestKey,
					}


					if (process === 'addBankAccount') {
						await validateOtpEmail(payload)
						this.$store.commit('bankAccount/setOtpModeAddBankAccount', 'sms')
					} else if (process === 'withdrawal') {
						await validateOtpEmailWithdrawal(payload)
						this.$store.commit('bankAccount/setOtpModeWithdrawal', 'sms')
					}

					// await this.simulateApi()

					Alert.close()
					return resolve()
				} catch (error) {
					let rejectType = 'stopTimer'

					let errorMessage
					if (error.response.data.data.status_code === 'OTPInvalid' || error.response.data.data.status_code === 'OTPValidateExceededLimit') {
						errorMessage = this.otpErrorCodeHandler(error)
						rejectType = 'continueTimer'

						if (error.response.data.data.status_code === 'OTPValidateExceededLimit') {
							rejectType = 'OTPValidateExceededLimit'
						}
					} else {
						errorMessage = handleErrorCode(error.response.data.data.status_code) || {
							title: error.response.data.data.message || 'Proses Invalid',
							message: error.response.data.data.message || 'Terdapat kesalahan pada sistem. Silakan coba lagi.'
						}
					}

					Alert.open({
						type: 'error',
						title: errorMessage.title,
						description: errorMessage.message,
						onClose: () => {
							// request key expired. Restart from the beginning
							if (error.response.data.data.status_code === 'BankAccountRequestInvalid') {
								this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
								this.$router.push({ name: 'Add Bank Account' })
							}

							if (error.response.data.data.status_code === 'OTPValidateExceededLimit') {
								if (process === 'addBankAccount') {
									this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
									this.$router.push({ name: 'Add Bank Account' })
								} else {
									this.$store.dispatch('bankAccount/removeCashWithdrawalLocalStorage')
								}
							}
						}
					})

					return reject(rejectType)
				}
			})
		},

		validateOtpSms(data, process = 'addBankAccount') {
			return new Promise(async (resolve, reject) => {
				Alert.open({
					type: 'loading',
					title: 'Sedang Memproses',
					description: 'Mohon tunggu sebentar'
				})

				try {
					const requestKey = process === 'addBankAccount' ? this.$store.state.bankAccount.requestKeyAddBankAccount : this.$store.state.bankAccount.requestKeyWithdrawal
					const payload = {
						...data,
						user_id: this.$store.state.authInfo.user_id,
						request_key: requestKey,
					}

					let alertTitle, alertDescription
					if (process === 'addBankAccount') {
						await validateOtpSms(payload)

						alertTitle = 'Berhasil Diproses'
						alertDescription = 'Tunggu hingga admin selesai memverifikasi dalam 1 hari kerja'

						this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
					} else if (process === 'withdrawal') {
						await validateOtpSmsWithdrawal(payload)

						alertTitle = 'Berhasil Diproses'
						alertDescription = 'Tunggu hingga kami selesai memverifikasi'

						this.$store.dispatch('bankAccount/removeCashWithdrawalLocalStorage')
					}

					Alert.open({
						type: 'success',
						title: alertTitle,
						description: alertDescription,
						onClose: () => {
							return resolve()
						}
					})
				} catch (error) {
					let rejectType = 'stopTimer'

					let errorMessage
					if (error.response.data.data.status_code === 'OTPInvalid' || error.response.data.data.status_code === 'OTPValidateExceededLimit') {
						errorMessage = this.otpErrorCodeHandler(error)
						rejectType = 'continueTimer'

						if (error.response.data.data.status_code === 'OTPValidateExceededLimit') {
							rejectType = 'OTPValidateExceededLimit'
						}
					} else {
						errorMessage = handleErrorCode(error.response.data.data.status_code) || {
							title: error.response.data.data.message || 'Proses Invalid',
							message: error.response.data.data.message || 'Terdapat kesalahan pada sistem. Silakan coba lagi.'
						}
					}

					Alert.open({
						type: 'error',
						title: errorMessage.title,
						description: errorMessage.message,
						onClose: () => {
							// request key expired. Restart from the beginning
							if (error.response.data.data.status_code === 'BankAccountRequestInvalid') {
								this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
								this.$router.push({ name: 'Add Bank Account' })
							}

							if (error.response.data.data.status_code === 'OTPValidateExceededLimit') {
								if (process === 'addBankAccount') {
									this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
									this.$router.push({ name: 'Add Bank Account' })
								} else {
									this.$store.dispatch('bankAccount/removeCashWithdrawalLocalStorage')
								}
							}
						}
					})

					return reject(rejectType)
				}
			})
		},

		resendOtp(process = 'addBankAccount') {
			return new Promise(async (resolve, reject) => {
				Alert.open({
					type: 'loading',
					title: 'Sedang Memproses',
					description: 'Mohon tunggu sebentar'
				})

				try {
					const requestKey = process === 'addBankAccount' ? this.$store.state.bankAccount.requestKeyAddBankAccount : this.$store.state.bankAccount.requestKeyWithdrawal
					const otpMode = process === 'addBankAccount' ? this.$store.state.bankAccount.otpModeAddBankAccount : this.$store.state.bankAccount.otpModeWithdrawal

					const payload = {
						user_id: this.$store.state.authInfo.user_id,
						request_key: requestKey,
						mode: otpMode
					}

					await resendOtp(payload)

					Alert.close()

					return resolve()
				} catch (error) {
					console.log('error', error)

					let errorMessage
					if (error.response.data.data.status_code === 'OTPInvalid' || error.response.data.data.status_code === 'OTPResendExceededLimit' || error.response.data.data.status_code === 'OTPInCooldown') {
						errorMessage = this.otpErrorCodeHandler(error)
					} else {
						errorMessage = handleErrorCode(error.response.data.data.status_code) || {
							title: error.response.data.data.message || 'Proses Invalid',
							message: error.response.data.data.message || 'Terdapat kesalahan pada sistem. Silakan coba lagi.'
						}
					}

					Alert.open({
						type: 'error',
						title: errorMessage.title,
						description: errorMessage.message,
						onClose: () => {
							// request key expired. Restart from the beginning
							if (error.response.data.data.status_code === 'NoActiveOTP') {
								if (process === 'addBankAccount') {
									this.$store.dispatch('bankAccount/removeAddBankAccountLocalStorage')
									this.$router.push({ name: 'Add Bank Account' })
								} else {
									this.$store.dispatch('bankAccount/removeCashWithdrawalLocalStorage')
								}
							}
						}
					})

					return reject()
				}
			})
		},

		otpErrorCodeHandler(error) {
			const attemptLeft = error.response.data.data.err_vars.max_attempts - error.response.data.data.err_vars.attempts
			let errorMessage = {
				title: 'ERROR',
				message: 'Terjadi kesalahan'
			}

			if (error.response.data.data.status_code === 'OTPInvalid') {
				errorMessage = {
					title: `Kode Tidak Sesuai, Sisa ${attemptLeft}x Kesempatan`,
					message: `Kode yang Anda masukkan tidak sesuai. Lakukan dengan benar atau Anda harus menunggu 24 jam untuk mencoba lagi`
				}
			} else if (error.response.data.data.status_code === 'OTPValidateExceededLimit' || error.response.data.data.status_code === 'OTPResendExceededLimit' || error.response.data.data.status_code === 'OTPInCooldown') {
				let cooldown
				const cooldownHours = new Decimal(error.response.data.data.err_vars.cooldown_secs).div(3600)
				const cooldownMinutes = new Decimal(error.response.data.data.err_vars.cooldown_secs).div(60)

				// If cooldown less than 1 minutes, show cooldown in seconds
				// If cooldown less than 1 hour, show cooldown in minutes
				// If cooldown more than 1 hour, show cooldown in hours
				if (cooldownHours >= 1) {
					cooldown = cooldownHours.toFixed(0) + ' jam'
				} else if (cooldownMinutes >= 1) {
					cooldown = cooldownMinutes.toFixed(0) + ' menit'
				} else {
					cooldown = error.response.data.data.err_vars.cooldown_secs + ' detik'
				}

				let maxCooldown = error.response.data.data.err_vars.max_cooldown_secs
				const cooldownHoursMax = new Decimal(maxCooldown).div(3600)
				const cooldownMinutesMax = new Decimal(maxCooldown).div(60)

				// If cooldown less than 1 minutes, show cooldown in seconds
				// If cooldown less than 1 hour, show cooldown in minutes
				// If cooldown more than 1 hour, show cooldown in hours
				if (cooldownHoursMax >= 1) {
					maxCooldown = cooldownHoursMax.toFixed(0) + ' jam'
				} else if (cooldownMinutesMax >= 1) {
					maxCooldown = cooldownMinutesMax.toFixed(0) + ' menit'
				} else {
					maxCooldown = maxCooldown + ' detik'
				}

				const attempts = error.response.data.data.err_vars.attempts
				const maxAttempts = error.response.data.data.err_vars.max_attempts
				const attemptLeft = maxAttempts - attempts

				if (error.response.data.data.status_code === 'OTPValidateExceededLimit') {
					errorMessage = {
						title: 'Proses Mencapai Batas',
						message: `Anda sudah melakukan total ${maxAttempts} kali kesalahan dalam memasukkan kode. Silakan coba lagi setelah ${cooldown}`
					}
				} else {
					if (attemptLeft > 0) {
						errorMessage = {
							title: `Sisa ${attemptLeft}x Kesempatan `,
							message: `Perhatikan kode dengan baik atau Anda harus menunggu ${maxCooldown} untuk dapat kode baru`
						}
					} else {
						errorMessage = {
							title: 'Proses Mencapai Batas',
							message: `Anda sudah melakukan total ${maxAttempts} kali pengiriman ulang kode OTP. Silakan coba lagi setelah ${cooldown}`
						}
					}
				}
			}

			return errorMessage
		},

		async getBankList() {
			try {
				const response = await getBankList()
				this.bankList = response.data.data.body
			} catch (error) {
				console.log('error', error)
			}
		},

		setBankList() {
			this.isLoadingGetBankList = true
			this.isErrorGetBankList = false

			this.getBankList().then(response => {
				this.isLoadingGetBankList = false

				this.bankList = response.data.data.body
			}).catch(() => {
				this.isLoadingGetBankList = false
				this.isErrorGetBankList = true
			})
		},

		getWithdrawalsFunc(params) {
			return new Promise(async (resolve, reject) => {
				try {
					const response = await getWithdrawals(params)
					this.listWithdrawals = response.data.transactions.map(item => {
						// Format: 5 November 2024, 12:00
						const date = new Date(item.transaction_date).toLocaleString('id-ID', {
							year: 'numeric',
							month: 'long',
							day: 'numeric',
							hour: '2-digit',
							minute: '2-digit'
						}).replace('pukul', '')

						return {
							_id: item._id,
							status: item.status === 'pending' ? 'Diproses' : item.status === 'process' ? 'Diproses' : item.status === 'success' ? 'Berhasil' : 'Gagal',
							transactionId: item.transaction_id,
							date: date,
							dateRaw: item.transaction_date,
							credit: {
								bankName: bankNameHandler(item.credit_bank_code, 'short'),
								bankLogo: logoSearch(item.credit_bank_code, 'bankSquare'),
								RpedNumber: item.credit_no,
								accountName: item.credit_name,
							},
							debit: {
								bankName: bankNameHandler(item.debit_bank_code, 'short'),
								bankLogo: logoSearch(item.debit_bank_code, 'bankSquare'),
								accountNumber: item.debit_no,
								accountName: item.debit_name,
							},
							description: item.desc,
							amount: item.amount,
							adminFee: item.admin_fee,
						}
					})
					return resolve(response)
				} catch (error) {
					console.log('error', error)
					return reject()
				}
			})
		},

		addRequestCashWithdrawalsFunc(data) {
			return new Promise(async (resolve, reject) => {
				this.withdrawalAmountErrors = []
				this.withdrawalDescriptionErrors = []

				// Amount validation
				// if data.transfer_type bifast: min 10.000 max 250.000.000
				// if data.transfer_type etb: min 1
				if (data.transfer_type === 'bifast') {
					if (data.amount < 10000) {
						this.withdrawalAmountErrors.push('Minimal penarikan Rp 10.000')
					}
					if (data.amount > 250000000) {
						this.withdrawalAmountErrors.push('Maksimal penarikan Rp 250.000.000')
					}
				} else if (data.transfer_type === 'etb') {
					if (data.amount < 10000) {
						this.withdrawalAmountErrors.push('Minimal penarikan Rp 10.000')
					}
				}

				if (this.withdrawalAmountErrors.length > 0) {
					return reject()
				}

				// Description validation
				if (data.description) {
					// min 3 characters, max 40 characters
					if (data.description.length < 3) {
						this.withdrawalDescriptionErrors.push('Deskripsi minimal 3 karakter')
					} else if (data.description.length > 40) {
						this.withdrawalDescriptionErrors.push('Deskripsi maksimal 40 karakter')
					}

					if (this.withdrawalDescriptionErrors.length > 0) {
						return reject()
					}
				} else { // if data.description is empty, remove description property
					delete data.description
				}

				Alert.open({
					type: 'confirm',
					title: 'Apakah Anda yakin ingin melakukan withdrawal Saldo RPED?',
					description: '',
					buttonConfirmText: 'Ya',
					onConfirm: async () => {
						Alert.close()
						Alert.open({
							type: 'loading',
							title: 'Sedang Memproses',
							description: 'Mohon tunggu sebentar'
						})

						try {
							const payload = {
								...data,
							}

							const response = await addRequestCashWithdrawals(payload)

							this.$store.dispatch('bankAccount/setRequestKeyWithdrawal', response.data.transaction.request_key)
							this.$store.commit('bankAccount/setOtpModeWithdrawal', 'email')

							Alert.open({
								type: 'success',
								title: 'Berhasil Diproses',
								description: 'Permintaan penarikan dana berhasil dikirim',
								onClose: () => {
									return resolve()
								}
							})
						} catch (error) {
							console.log('error', error)

							let errorMessage = handleErrorCode(error.response.data.data.status_code) || {
								title: error.response.data.data.message || 'Proses Invalid',
								message: error.response.data.data.message || 'Terdapat kesalahan pada proses penarikan. Silakan coba lagi.'
							}

							Alert.open({
								type: 'error',
								title: errorMessage.title,
								description: errorMessage.message
							})

							return reject()
						}
					},
					onCancel: () => {
						Alert.close()
					}
				})
			})
		},
	}
}
